import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiIconButton = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: {
      borderRadius: '8px',
      color: 'var(--mui-palette-text-primary)',
      height: 'var(--IconButton-size)',
      width: 'var(--IconButton-size)',
      '&:hover': { backgroundColor: 'var(--mui-palette-action-hover)' },
      '&:focus-visible': {
        outline: '2px solid var(--mui-palette-primary-text)',
      },
    },
    colorPrimary: {
      color: 'var(--mui-palette-primary-text)',
      '&:hover': { backgroundColor: 'var(--mui-palette-primary-hovered)' },
      '&:active': { backgroundColor: 'var(--mui-palette-primary-activated)' },
    },
    colorSecondary: {
      color: 'var(--mui-palette-secondary-text)',
      '&:hover': { backgroundColor: 'var(--mui-palette-secondary-hovered)' },
      '&:active': { backgroundColor: 'var(--mui-palette-secondary-activated)' },
    },
    colorInfo: {
      color: 'var(--mui-palette-info-text)',
      '&:hover': { backgroundColor: 'var(--mui-palette-info-hovered)' },
      '&:active': { backgroundColor: 'var(--mui-palette-info-activated)' },
    },
    colorSuccess: {
      color: 'var(--mui-palette-success-text)',
      '&:hover': { backgroundColor: 'var(--mui-palette-success-hovered)' },
      '&:active': { backgroundColor: 'var(--mui-palette-success-activated)' },
    },
    colorWarning: {
      color: 'var(--mui-palette-warning-text)',
      '&:hover': { backgroundColor: 'var(--mui-palette-warning-hovered)' },
      '&:active': { backgroundColor: 'var(--mui-palette-warning-activated)' },
    },
    colorError: {
      color: 'var(--mui-palette-error-text)',
      '&:hover': { backgroundColor: 'var(--mui-palette-error-hovered)' },
      '&:active': { backgroundColor: 'var(--mui-palette-error-activated)' },
    },
    sizeSmall: { '--IconButton-size': '32px' },
    sizeMedium: { '--IconButton-size': '40px' },
    sizeLarge: { '--IconButton-size': '48px' },
  },
} satisfies Components<Theme>['MuiIconButton'];
